import { Component, OnInit } from '@angular/core';
import { switchMap, iif } from 'rxjs';

import { ProfileBaseStoreService } from '../../store/services/profile-base-store.service';
import { AdditionalProfileStoreService } from '@additional-profile/store/services/additional-profile-store.service';
import { SettingsStoreService } from '@settings/store/services/settings-store.service';
import { ProfileStoreService } from '@profile/store/services/profile-store.service';
import { DestroyableDirective, InViewportDirective } from 'ng-in-viewport';
import { RpcButtonComponent } from '../../../../../core-modules/controls/components/rpc-button/rpc-button.component';
import { ProfileSettingsComponent } from '../../components/profile-settings/profile-settings.component';
import { ScrollToTopComponent } from '../../../../../core-modules/layout/scroll-to-top/scroll-to-top.component';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'profile-settings-page',
    templateUrl: './profile-settings-page.component.html',
    styleUrls: ['./profile-settings-page.component.scss'],
    imports: [DestroyableDirective, InViewportDirective, RpcButtonComponent, ProfileSettingsComponent, ScrollToTopComponent, AsyncPipe, TranslateModule]
})
export class ProfileSettingsPageComponent implements OnInit {
    public readonly isSelfProfile$ = this.profileBaseStoreService.isSelfProfile$;
    public readonly settings$ = this.profileBaseStoreService.isSelfProfile$.pipe(
        switchMap(isSelfProfile => iif(() => isSelfProfile, this.settingsStoreService.getSettings(), this.additionalProfileStoreService.settings$))
    );

    public readonly newMatchSettings$ = this.profileBaseStoreService.isSelfProfile$.pipe(
        switchMap(isSelfProfile => iif(() => isSelfProfile, this.settingsStoreService.getNewMatchSettings(), this.additionalProfileStoreService.newMatchSettings$))
    );

    public readonly hasPhones$ = this.profileBaseStoreService.isSelfProfile$.pipe(
        switchMap(isSelfProfile => iif(() => isSelfProfile, this.profileStoreService.hasPhones$, this.additionalProfileStoreService.hasPhones$))
    );

    public readonly hasSmsAlertsNumber$ = this.profileBaseStoreService.isSelfProfile$.pipe(
        switchMap(isSelfProfile => iif(() => isSelfProfile, this.profileStoreService.hasSmsAlertsNumber$, this.additionalProfileStoreService.hasSmsAlertsNumber$))
    );

    public isMinimizedToolbar = false;

    constructor(
        private readonly profileBaseStoreService: ProfileBaseStoreService,
        private readonly settingsStoreService: SettingsStoreService,
        private readonly additionalProfileStoreService: AdditionalProfileStoreService,
        private readonly profileStoreService: ProfileStoreService,
    ) { }

    public ngOnInit() {
        this.profileBaseStoreService.loadProfileData();
        this.profileBaseStoreService.loadSettings();
        this.profileBaseStoreService.loadNewMatchSettings();
    }

    public onNavigateBack(): void {
        this.profileBaseStoreService.navigateToProfile();
    }

    public onToolbarMinimizerAnchorViewportChange({ target, visible }: { target: Element; visible: boolean }): void {
        this.isMinimizedToolbar = !visible;
    }
}
